import { getUrlExtension } from "../../helpers/Utils";
import {
  GET_ORDER,
  GET_ORDERS,
  GET_ORDERS_AMOUNT,
  UPDATE_SUPPLYORDERS,
  POST_ORDER_ROW,
  DELETE_ORDER_ROW,
  LOADING_ORDERS,
  POST_COMMENTS_TO_ORDERS,
  ADD_CONTRACT,
  UPDATE_CONTRACT,
  DELETE_CONTRACT,
  ADD_CONTRACT_ITEM,
  UPDATE_CONTRACT_ITEM,
  DELETE_CONTRACT_ITEM,
  ADD_ORDER_DOCUMENT,
  DELETE_ORDER_DOCUMENT,
  UPDATE_ORDER_DOCUMENT,
  CREATE_SMS_ITEM,
  POST_ORDER_SHIPPING,
  SEND_EMAIL,
  CREATE_ORDER_STATUS,
  FIRST_ADD_CONTRACT,
  FIRST_DELETE_CONTRACT,
  CHANGE_CONTRACT_ITEMS,
  UPDATE_ORDER,
  UPDATE_SERIAL_NUMBER,
  UPDATE_SERIAL_NUMBER_STATE,
  POST_TO_RIVILE,
  UPDATE_ORDER_SOCKETS,
  ORDER_CREATE_INVOICE,
  LOADING_ORDER,
  POST_ORDER_ROW_GOODS,
  UPDATE_ORDER_ROW_GOODS,
  DELETE_ORDER_ROW_GOODS,
  POST_PAYMENT_ORDER,
  UPDATE_PAYMENT_ORDER,
  EDIT_PAYMENT_ORDER,
  DELETE_PAYMENT_ORDER,
  UPDATE_CART_RULES,
  CREATE_WAITING_PAYMENT,
  GET_WAITING_PAYMENTS,
  UPDATE_SUPPLYING,
  SET_COD_SELECTED,
  SET_GLOBAL_MODAL,
  GET_ORDERS_SHIPMENTS_OVER_80_KG,
} from "../Actions/types";

const initialStateComments = {
  comment_ka: false,
  comment_management: false,
  comment_logistic: false,
};

const initialState = {
  orders: [],
  order_histories: [],
  contracts: [],
  invoices: [],
  order_rows: [],
  order_documents: [],
  sms_sendings: [],
  shipments: [],
  payment: {},
  payments: [],
  money_refund_items: [],
  order: {},
  totals: "loading",
  total_amount: "loading",
  total_urgent: "loading",
  total_vip: "loading",
  total_shipments_with_error: "loading",
  total_invoices_with_error: "loading",
  showID: 0,
  loading_orders: false,
  loading_order: false,
  error_order: null,
  //
  or_quantity_manual: {},
  validate_comments: initialStateComments,
  bulk_shipments: {},
  settings: {
    total_amount: false,
    page: 1,
    page_count: 25,
    params_filter: "",
  },
  isCodSelected: false,
  globalModal: {
    isOpen: false,
    numbersArray: [],
    modalName: "",
  },
  ordersShipmentsOver80Kg: [],
};

export default function (state = initialState, action) {
  // console.log("ACTION TYPE: ",action.type);
  switch (action.type) {
    case "VALIDATE_COMMENTS":
      return {
        ...state,
        validate_comments: {
          ...state.validate_comments,
          ...action.payload,
        },
      };
    case LOADING_ORDERS:
      return {
        ...state,
        loading_orders: true,
        totals: "loading",
      };

    case "SET_SETTINGS":
      return {
        ...state,
        settings: action.payload,
      };
    case POST_COMMENTS_TO_ORDERS:
      let updateData = [...state.orders];
      const updateComments = (element) =>
        element.id === action.payload.order_id;
      const findIndexOrderForComment = updateData.findIndex(updateComments);
      if (POST_COMMENTS_TO_ORDERS !== -1) {
        updateData[findIndexOrderForComment].comments.push(action.payload);
      }

      return {
        ...state,
        orders: updateData,
        order: {
          ...state.order,
          comments: [...state.order.comments, action.payload],
        },
      };

    case ORDER_CREATE_INVOICE:
      let arrOrderCreateInvoice = [...state.orders];
      const findIndexOrderCreateInvoice = state.orders.findIndex(
        (item) => item.id === action.payload.id
      );
      if (findIndexOrderCreateInvoice !== -1) {
        arrOrderCreateInvoice[findIndexOrderCreateInvoice].invoice_number =
          action.payload.invoice_number;
      }
      return {
        ...state,
        order: {
          ...state.order,
          invoice_number: action.payload.invoice_number,
        },
        orders: arrOrderCreateInvoice,
      };
    case "ORDER_INVOICES":
      const order_histories_in_oi = action.payload.order_histories;
      return {
        ...state,
        invoices: [...state.invoices, ...action.payload.invoices],
        order_histories: order_histories_in_oi || state.order_histories,
        orders: state.orders.map((e) =>
          e.id == action.payload.invoices[0].order_id
            ? {
                ...e,
                order_invoices: [
                  ...e.order_invoices,
                  ...action.payload.invoices,
                ],
                status: order_histories_in_oi
                  ? order_histories_in_oi[0].status
                  : e.status,
              }
            : e
        ),
      };
    case "ORDER_INVOICE_REMOVE":
      return {
        ...state,
        invoices: [...state.invoices].filter(
          (e) => e.id !== action.payload.item_id
        ),
        orders: state.orders.map((e) =>
          e.id == action.payload.order_id
            ? {
                ...e,
                order_invoices: [...e.order_invoices].filter(
                  (e) => e.id !== action.payload.item_id
                ),
              }
            : e
        ),
      };
    case POST_ORDER_ROW:
      return {
        ...state,
        order_rows: postOrderRow(action.payload, state),
        orders: postOrdersRow(action.payload, state, action.payload2),
      };
    case "ORDER_ROW_RETURNS_RECALCULATE":
      return {
        ...state,
        order_rows: state.order_rows.map((row) => ({
          ...row,
          returns_count: action.payload[row.id]?.used || 0,
        })),
        orders: state.orders.map((row) => {
          if (row.id == state.order.id) {
            return {
              ...row,
              order_rows: row.order_rows.map((order_row) => ({
                ...order_row,
                returns_count: action.payload[order_row.id]?.used || 0,
              })),
            };
          }
          return row;
        }),
      };
    case "SET_ORDER_ROWS":
      return {
        ...state,
        order_rows: action.payload,
      };
    case "SET_ORDER_ROWS_WITH_ORDER":
      return {
        ...state,
        order_rows: action.payload.order_rows,
        orders: action.payload.orders,
      };
    case UPDATE_ORDER:
      return {
        ...state,
        ...updateOrder(action.payload, state),
      };
    case UPDATE_SUPPLYORDERS:
      let orderId = action.payload.order_id;
      let itemId = action.payload.id;
      let updateOrdersArray = [...state.orders];
      if (orderId && itemId) {
        let findObjOrder = updateOrdersArray.findIndex(
          (findIndex) => findIndex.id === orderId
        );
        if (findObjOrder !== -1) {
          let findItem = updateOrdersArray[findObjOrder].order_rows.findIndex(
            (item) => item.id == itemId
          );
          updateOrdersArray[findObjOrder].order_rows[findItem] = action.payload;
        }
      }
      return {
        ...state,
        orders: updateOrdersArray,
      };

    case DELETE_ORDER_ROW: {
      return {
        ...state,
        order_rows: deleteOrderRow(action.payload, state),
        orders: deleteOrdersRow(action.payload, state, action.payload2),
      };
    }
    case UPDATE_SUPPLYING:
      return {
        ...state,
        ...updateOrderRowSupplyings(action.payload, state),
      };
    case GET_ORDERS:
      return {
        ...state,
        bulk_shipments: {},
        orders: orderMainRowsBuilder(action.payload.data),
        totals: action.payload.totals,
        loading_orders: false,
      };
    case GET_ORDERS_AMOUNT:
      return {
        ...state,
        total_amount: action.payload.total_amount,
        total_urgent: action.payload.total_urgent,
        total_vip: action.payload.total_vip,
        total_shipments_with_error: action.payload.total_shipments_with_error,
        total_invoices_with_error: action.payload.total_invoices_with_error,
      };
    case LOADING_ORDER:
      return {
        ...state,
        loading_order: true,
        error_order: null,
      };
    case GET_ORDER:
      return {
        ...state,
        contracts: contractStatus(action.payload.contracts),
        order_documents: orderDocumentsBuilder(action.payload.order_documents),
        order_histories: action.payload.order_histories,
        order_rows: orderRowsBuilder(action.payload.order_rows),
        payments: action.payload.payments,
        shipments: action.payload.shipments,
        money_refund_items: action.payload.money_refund_items,
        sms_sendings: action.payload.sms_sendings,
        order: action.payload.order,
        invoices: action.payload.invoices,
        showID: action.payload_id,
        loading_order: false,
        error_order: false,
        validate_comments: initialStateComments,
      };
    case "SET_ORDER_ERROR":
      return {
        ...state,
        loading_order: false,
        error_order: action.payload,
      };
    case "NEW_ORDER":
      return {
        ...state,
        orders: [action.payload, ...state.orders],
        totals: state.totals + 1,
      };
    case ADD_CONTRACT:
      return {
        ...state,
        contracts: addContractItemNew(action.payload, state),
      };
    case FIRST_ADD_CONTRACT:
      return {
        ...state,
        contracts: [action.payload, ...state.contracts],
      };
    case FIRST_DELETE_CONTRACT:
      return {
        ...state,
        contracts: state.contracts.filter(
          (filter) => filter.id !== action.payload
        ),
      };
    case CHANGE_CONTRACT_ITEMS:
      return {
        ...state,
        contracts: changeContractItems(action.payload, state),
      };
    case UPDATE_CONTRACT:
      return {
        ...state,
        contracts: updateContract(action.payload, state),
      };
    case DELETE_CONTRACT:
      return {
        ...state,
        contracts: state.contracts.filter(
          (item) => item.id !== action.payload.id
        ),
      };
    case ADD_CONTRACT_ITEM:
      let addContractItem = [...state.contracts];
      let findId = state.contracts.findIndex(
        (find) => find.id == action.payload.contract_id
      );
      if (findId !== -1) {
        let add_contract_itemObj = {
          ...action.payload,
          update: "update",
        };
        addContractItem[findId].contract_items.push(add_contract_itemObj);
      }

      return {
        ...state,
        contracts: addContractItem,
      };
    case UPDATE_CONTRACT_ITEM:
      const updateContractItemObj = {
        ...action.payload,
        update: "update",
      };
      return {
        ...state,
        contracts: updateContractItem(updateContractItemObj, state),
      };
    case DELETE_CONTRACT_ITEM:
      return {
        ...state,
        contracts: deleteContract(action.payload, state),
      };

    case ADD_ORDER_DOCUMENT:
      const order_document_count2 = [...state.order_documents, action.payload];

      return {
        ...state,
        order_documents: [...state.order_documents, action.payload],
        orders: hasDocumentCheck(action.payload, state, order_document_count2),
      };
    case DELETE_ORDER_DOCUMENT:
      const order_document_count = [...state.order_documents].filter(
        (item) => item.id !== action.payload.id
      );
      return {
        ...state,
        order_documents: order_document_count,
        orders: hasDocumentCheck(action.payload, state, order_document_count),
      };
    case UPDATE_ORDER_DOCUMENT:
      return {
        ...state,
        order_documents: updateOrderDocument(action.payload, [
          ...state.order_documents,
        ]),
      };
    case CREATE_SMS_ITEM:
      return {
        ...state,
        sms_sendings: [action.payload, ...state.sms_sendings],
        orders: hasSmsCheck(action.payload, state),
      };

    case "SET_SMS_ITEMS":
      return {
        ...state,
        sms_sendings: action.payload,
      };
    case POST_ORDER_SHIPPING:
      const post_order_shipping = [...state.shipments, action.payload.shipment];
      return {
        ...state,
        or_quantity_manual: {},
        shipments: post_order_shipping,
        order_rows: orderRowsBuilder(action.payload.order_rows),
        orders: orderMainRowsBuilder(
          state.orders.map((e) =>
            e.id == action.payload.shipment.service_order_id
              ? {
                  ...e,
                  shipments: [...e.shipments, action.payload.shipment],
                  order_rows: action.payload.order_rows,
                }
              : e
          )
        ),
      };
    case "ORDER_ROW_DISABLED_AT":
      return {
        ...state,
        shipments: action.payload.shipments
          ? action.payload.shipments
          : state.shipments,
        order_histories: action.payload.order_histories
          ? action.payload.order_histories
          : state.order_histories,
        order_rows: orderRowsBuilder(action.payload.order_rows),
        orders: orderMainRowsBuilder(
          state.orders.map((e) =>
            e.id == action.payload.id
              ? {
                  ...e,
                  order_rows: action.payload.order_rows,
                  shipments: action.payload.shipments
                    ? action.payload.shipments
                    : e.shipments,
                }
              : e
          )
        ),
      };
    case SEND_EMAIL:
      let getContracts = [...state.contracts];
      const contractFindId = getContracts.findIndex(
        (find) => find.id === action.payload.contract_id
      );
      if (contractFindId !== -1)
        getContracts[contractFindId].contract_emails.push(action.payload);

      return {
        ...state,
        contracts: getContracts,
      };
    case CREATE_ORDER_STATUS:
      return createOrderStatus(action.payload, state);
    case "ORDER_COD_UPDATE":
      return {
        ...state,
        order: {
          ...state.order,
          cod: action.payload.cod,
        },
        orders: [...state.orders].map((e) =>
          e.id == action.payload.order_id
            ? {
                ...e,
                cod: action.payload.cod,
              }
            : e
        ),
      };
    case UPDATE_SERIAL_NUMBER:
      return {
        ...state,
        orders: updateSerialNumber(action.payload, state, action.payload2),
        order_rows: updateSerialNumber(action.payload, state),
      };
    case POST_TO_RIVILE:
      let toRivile = [...state.orders];

      const findIndex = toRivile.findIndex(
        (find) => find.id == action.payload.id
      );
      if (findIndex !== -1) {
        toRivile[findIndex].billing_address = action.payload.data;
      }

      return {
        ...state,
        orders: toRivile,
        order: { ...state.order, billing_address: action.payload.data },
      };
    case UPDATE_SERIAL_NUMBER_STATE:
      return {
        ...state,
        order_rows: action.payload,
      };
    case UPDATE_ORDER_SOCKETS:
      return {
        ...state,
        ...updateOrder(action.payload, state),
      };
    case POST_ORDER_ROW_GOODS:
      const existingRowIndex = state.order_rows.findIndex(
        (row) => row.id == action.payload.items.id
      );
      const newOrderRow = {
        ...action.payload.items,
        supplyings: [],
        quantity: Number(action.payload.items.quantity),
      };
      return {
        ...state,
        order_rows:
          existingRowIndex !== -1
            ? state.order_rows.map((row, idx) =>
                idx === existingRowIndex ? newOrderRow : row
              )
            : [...state.order_rows, newOrderRow],
        order: { ...state.order, total_price: action.payload.total_price },
        orders: postOrderRowGoods(action.payload, state),
      };
    case "CABLE_POST_ORDER_ROW":
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_ORDER_ROW_GOODS:
      return {
        ...state,
        order: action.payload.total_price
          ? { ...state.order, total_price: action.payload.total_price }
          : state.order,
        order_rows: updateOrderRowGoodsShow(action.payload, state),
        orders: updateOrderRowGoods(action.payload, state),
      };
    case DELETE_ORDER_ROW_GOODS:
      return {
        ...state,
        order_rows: action.payload.order_rows,
        orders: deleteOrderRowGoods(action.payload, state),
        order: {
          ...state.order,
          total_price: action.payload.total_price,
          order_rows: action.payload.order_rows,
        },
      };
    // waiting payments
    case GET_WAITING_PAYMENTS:
      return {
        ...state,
        orders: state.orders.map((e) => {
          if (e.id == state.order.id) {
            return {
              ...e,
              waiting_payments: action.payload,
            };
          }
          return e;
        }),
        order: {
          ...state.order,
          waiting_payments: action.payload,
        },
      };
    case CREATE_WAITING_PAYMENT:
      return {
        ...state,
        orders: state.orders.map((e) => {
          if (e.id == action.payload.order_id) {
            return {
              ...e,
              waiting_payments: [...e.waiting_payments, action.payload],
            };
          }
          return e;
        }),
        order: state.order
          ? {
              ...state.order,
              waiting_payments: [
                ...state.order.waiting_payments,
                action.payload,
              ],
            }
          : state.order,
      };
    case "REMOVE_WAITING_PAYMENT":
      return {
        ...state,
        orders: state.orders.map((e) => {
          if (e.id == action.payload.order_id) {
            return {
              ...e,
              waiting_payments: e.waiting_payments.filter(
                (waiting_payment) =>
                  waiting_payment.id !== action.payload.waiting_payment_id
              ),
            };
          }
          return e;
        }),
        order: state.order
          ? {
              ...state.order,
              waiting_payments: state.order.waiting_payments.filter(
                (waiting_payment) =>
                  waiting_payment.id !== action.payload.waiting_payment_id
              ),
            }
          : state.order,
      };

    // payment
    case POST_PAYMENT_ORDER:
      return {
        ...state,
        payments: [...state.payments, action.payload],
      };
    case EDIT_PAYMENT_ORDER:
      return {
        ...state,
        payment: { ...action.payload },
      };
    case UPDATE_PAYMENT_ORDER:
      return {
        ...state,
        payments: updatePaymentOrder(action.payload, state),
      };
    case DELETE_PAYMENT_ORDER:
      return {
        ...state,
        payments: [...state.payments].filter(
          (filt) => filt.id !== action.payload
        ),
      };
    case "POST_CART_RULES":
      return {
        ...state,
        order: {
          ...state.order,
          total_price: action.total_price,
          order_cart_rules: [...state.order.order_cart_rules, action.payload],
        },
        // TODO: cia
        orders: updateTotalPrice(action, state),
      };
    case UPDATE_CART_RULES:
      return {
        ...state,
        order: {
          ...state.order,
          total_price: action.total_price,
          order_cart_rules: simpleUpdate(
            action.payload,
            state.order.order_cart_rules
          ),
        },
        // TODO: cia
        orders: updateTotalPrice(action, state),
      };
    case "DELETE_CART_RULES":
      return {
        ...state,
        order: {
          ...state.order,
          total_price: action.payload.total_price,
          order_cart_rules: state.order.order_cart_rules.filter(
            ({ id }) => id !== action.payload.order_cart_rule_id
          ),
        },
        order_rows: orderRowsBuilder(action.payload.order_rows),
        orders: orderMainRowsBuilder(
          state.orders.map((e) =>
            e.id == action.payload.order_id
              ? {
                  ...e,
                  total_price: action.payload.total_price,
                  order_rows: action.payload.order_rows,
                  order_cart_rules: e.order_cart_rules.filter(
                    ({ id }) => id !== action.payload.order_cart_rule_id
                  ),
                }
              : e
          )
        ),
      };
    case "REMOVE_SHIPMENT_ORDER":
      const remove_shipment_order = action.payload.shipment
        ? state.shipments.map((e) =>
            e.id == action.payload.id ? { ...e, ...action.payload.shipment } : e
          )
        : state.shipments.filter((e) => e.id !== action.payload.id);
      return {
        ...state,
        shipments: remove_shipment_order,
        order_rows: orderRowsBuilder(action.payload.order_rows),
        orders: orderMainRowsBuilder(
          state.orders.map((e) =>
            e.id == action.payload.orderId
              ? {
                  ...e,
                  shipments: remove_shipment_order,
                  order_rows: action.payload.order_rows,
                }
              : e
          )
        ),
      };
    case "UPDATE_OR_QUANTITY_MANUAL":
      return {
        ...state,
        or_quantity_manual: {
          ...state.or_quantity_manual,
          ...action.payload,
        },
      };
    case "UPDATE_BULK_COMMENT_STATUS":
      return {
        ...state,
        orders: state.orders.map((d) => {
          if (action.payload.orders_ids.includes(d.id)) {
            let obj = { ...d };
            const comment = action.payload.comments.find(
              (e) => e.order_id == d.id
            );
            if (comment) {
              obj.comments.push(comment);
            }
            if (action.payload.statuses) {
              obj.status_id = action.payload.statuses.id;
              obj.status = action.payload.statuses;
            }
            return obj;
          }
          return d;
        }),
      };
    case "UPDATE_BULK_SUPPLYINGS":
      return {
        ...state,
        orders: state.orders.map((d) => {
          if (action.payload.orders_ids.includes(d.id)) {
            return {
              ...d,
              order_rows: d.order_rows.map((e) => {
                const supplying = action.payload.supplyings.find(
                  (fi) => fi.service_order_row_id == e.id
                );
                if (supplying) {
                  let supplyings = [...e.supplyings];
                  supplyings.push(supplying);
                  return {
                    ...e,
                    supplyings,
                  };
                }
                return e;
              }),
            };
          }
          return d;
        }),
      };
    case "POST_MONEY_REFUND":
      return {
        ...state,
        money_refund_items: [...state.money_refund_items, action.payload],
      };
    case "REMOVE_MONEY_REFUND":
      return {
        ...state,
        money_refund_items: state.money_refund_items.filter(
          (d) => d.id !== action.payload
        ),
      };
    // bulk_shipments actions
    case "UPDATE_BULK_SHIPMENTS":
      // console.log("UPDATE_BULK_SHIPMENTS: ", action.payload);
      return {
        ...state,
        bulk_shipments: action.payload,
      };
    case "UPDATE_BULK_SHIPMENT_ITEM":
      let old = { ...state.bulk_shipments };
      old[action.payload.order_id] = action.payload.data;
      return {
        ...state,
        bulk_shipments: old,
      };
    case "UPDATED_ORDERS_AFTER_BULK_SHIPMENT":
      return {
        ...state,
        orders: [...state.orders].map((order) => {
          if (action.payload[order.id]) {
            let reOrder = {
              ...order,
              order_rows: action.payload[order.id].order_rows,
              status: action.payload[order.id].status,
            };

            if (
              !reOrder.shipments.some(
                (shipment) =>
                  shipment.id == action.payload[order.id].shipment.id
              )
            ) {
              reOrder.shipments = [
                ...reOrder.shipments,
                action.payload[order.id].shipment,
              ];
            }

            return reOrder;
          }
          return order;
        }),
      };
    case SET_COD_SELECTED:
      return {
        ...state,
        isCodSelected: action.payload,
      };
    case SET_GLOBAL_MODAL:
      return {
        ...state,
        globalModal: {
          isOpen: action.payload.isOpen,
          numbersArray: action.payload.numbersArray,
          modalName: action.payload.modalName,
        },
      };
    case GET_ORDERS_SHIPMENTS_OVER_80_KG:
      return {
        ...state,
        ordersShipmentsOver80Kg: action.payload,
      };
    default:
      // console.log(`TYPE MISSED: ${action.type}`);
      return state;
  }
}

const createOrderStatus = (payload, state) => {
  const order_id = state.order?.id;
  const last_status = payload.order_histories[0];
  const res_order_id = last_status.order_id;
  let new_state = { ...state };

  // Update only if opened modal
  if (order_id == res_order_id) {
    new_state.order_histories = payload.order_histories;
    new_state.order = {
      ...new_state.order,
      ...payload.order,
      status: last_status.status,
    };
  }
  // Update for index preview
  new_state.orders = [...state.orders].map((e) =>
    e.id == res_order_id
      ? {
          ...e,
          ...payload.order,
          status: last_status.status,
        }
      : e
  );
  return new_state;
};

const orderDocumentsBuilder = (arr) => {
  const array = [...arr].map((e) => ({
    ...e,
    format: getUrlExtension(e.asset.url),
  }));
  return array;
};

const updateTotalPrice = (action, state) => {
  let orders = [...state.orders];
  const findIndex = orders.findIndex((e) => e.id == action.payload.order_id);
  if (findIndex !== -1) {
    const find_rule = orders[findIndex].order_cart_rules.findIndex(
      (e) => e.id == action.payload.id
    );
    if (find_rule !== -1) {
      orders[findIndex].order_cart_rules[find_rule] = action.payload;
    }
    orders[findIndex].total_price = action.total_price;
  }
  return orders;
};

const simpleUpdate = (payload, state) => {
  let oldArr = [...state];
  const findIndexArr = oldArr.findIndex(({ id }) => id == payload.id);
  if (findIndexArr !== -1) {
    oldArr[findIndexArr] = payload;
  }
  return oldArr;
};

const updatePaymentOrder = (payload, state) => {
  let paymentsArray = [...state.payments];
  const findIndexArr = paymentsArray.findIndex(
    (findI) => findI.id == payload.id
  );
  if (findIndexArr !== -1) {
    paymentsArray[findIndexArr] = payload;
  }
  return paymentsArray;
};

const updateSerialNumber = (payload, state, payload2) => {
  let orderArray = [...state.orders];
  let order_rowsArray = [...state.order_rows];
  if (payload2) {
    const findOrder = orderArray.findIndex((find) => find.id == payload2);
    if (findOrder !== -1) {
      const row = orderArray[findOrder].order_rows;
      const findRow = row.findIndex((find) => find.id == payload.id);
      if (findRow !== -1) {
        row[findRow] = {
          ...row[findRow],
          ...payload,
        };
      }
    }
    return orderArray;
  } else {
    const rowShow = order_rowsArray;
    const findRowShow = rowShow.findIndex((find) => find.id == payload.id);
    if (findRowShow !== -1) {
      rowShow[findRowShow] = {
        ...rowShow[findRowShow],
        ...payload,
      };
    }
    return order_rowsArray;
  }
};

const hasSmsCheck = (action, data) => {
  let oldData = [...data.orders];
  const findIndex = oldData.findIndex((find) => find.id == action.order_id);
  if (findIndex !== -1) {
    oldData[findIndex].has_sms = true;
  }
  return oldData;
};

const hasDocumentCheck = (action, data, docData) => {
  let oldData = [...data.orders];
  const findIndex = oldData.findIndex((find) => find.id == action.order_id);
  if (findIndex !== -1) {
    oldData[findIndex].has_documents = docData.length == 0 ? false : true;
  }
  return oldData;
};

const payment_types = (payload) => {
  let newArray = [
    {
      label: "ALL",
      value: "",
    },
  ];
  payload.forEach((item) => {
    if (!item.order_shop_id) return;
    if (!item.module_name) return;
    const findIndex = newArray.findIndex(
      (find) =>
        find.value == item.title &&
        find.order_shop_id == item.order_shop_id &&
        find.module_name == item.module_name
    );
    if (findIndex == -1) {
      newArray.push({
        value: item.title,
        label: `[${item?.order_shop?.identifier || ""}] ${item.title}`,
        order_shop_id: item.order_shop_id,
        module_name: item.module_name,
      });
    }
  });
  return newArray;
};

const changeContractItems = (payload, state) => {
  let oldStateContracts = [...state.contracts];
  oldStateContracts[payload.id].contract_items = payload.data;
  return oldStateContracts;
};

const addContractItemNew = (items, state) => {
  let oldStateContracts = [...state.contracts];
  const findIndex = oldStateContracts.findIndex((find) => find.id === items.id);
  if (findIndex !== -1) {
    let newObj = {
      ...items.data,
      action_status: "update",
      createdNew: true,
    };
    oldStateContracts[findIndex] = newObj;
  }
  return oldStateContracts;
};

const contractStatus = (items) => {
  let newArray = [];
  items.forEach((item) => {
    newArray.push({
      ...item,
      action_status: "update",
    });
  });
  return newArray;
};

const updateOrderDocument = (data, state) => {
  let nextIndex = state.findIndex((item) => item.id === data.id);
  if (nextIndex !== -1) {
    state[nextIndex] = data;
  }
  return state;
};

const updateContract = (data, state) => {
  let contracts = [...state.contracts];
  const findIndex = contracts.findIndex((item) => item.id == data.id);
  if (findIndex !== -1) {
    let obj = {
      ...data,
      action_status: "update",
    };
    contracts[findIndex] = obj;
  }
  return contracts;
};

const deleteContract = (data, state) => {
  let contracts = [...state.contracts];
  const findIndex = contracts.findIndex((item) => item.id == data.contract_id);
  if (findIndex !== -1) {
    contracts[findIndex].contract_items = contracts[
      findIndex
    ].contract_items.filter((item) => item.id !== data.id);
  }
  return contracts;
};

const updateContractItem = (data, state) => {
  let contracts = [...state.contracts];
  const findIndex = contracts.findIndex((item) => item.id == data.contract_id);
  if (findIndex !== -1) {
    let secondFindArray = contracts[findIndex].contract_items;
    let secondFind = secondFindArray.findIndex((find) => find.id == data.id);
    if (secondFind !== -1) {
      let obj = {
        ...data,
        action_status: "update",
      };
      secondFindArray[secondFind] = obj;
    }
  }
  return contracts;
};

const postOrderRow = (itemAction, state) => {
  let order_ROW = [...state.order_rows];
  const findId = order_ROW.findIndex(
    (item) => item.id == itemAction.service_order_row_id
  );
  if (findId !== -1) {
    let haveObj = order_ROW[findId];
    haveObj.supplyings.push(itemAction);
  }
  return order_ROW;
};
const postOrdersRow = (itemAction, state, allId) => {
  let orders_row = [...state.orders];
  const findOrder = orders_row.findIndex((item) => item.id == allId.id);
  if (findOrder !== -1) {
    let findItem = orders_row[findOrder].order_rows.findIndex(
      (item) => item.id == allId.order
    );
    if (findItem !== -1) {
      orders_row[findOrder].order_rows[findItem].supplyings.push(itemAction);
    }
  }
  return orders_row;
};

const deleteOrderRow = (itemAction, state) => {
  let order_ROW = [...state.order_rows];
  const findId = order_ROW.findIndex(
    (item) => item.id == itemAction.service_order_row_id
  );
  if (findId !== -1) {
    let haveObj = order_ROW[findId];
    haveObj.supplyings = haveObj.supplyings.filter(
      (item) => item.id !== itemAction.id
    );
  }
  return order_ROW;
};

const deleteOrdersRow = (itemAction, state, allId) => {
  let orders_row = [...state.orders];
  const findOrder = orders_row.findIndex((item) => item.id == allId.id);
  if (findOrder !== -1) {
    let findItem = orders_row[findOrder].order_rows.findIndex(
      (item) => item.id == allId.order
    );
    if (findItem !== -1) {
      orders_row[findOrder].order_rows[findItem].supplyings = orders_row[
        findOrder
      ].order_rows[findItem].supplyings.filter(
        (item) => item.id !== itemAction.id
      );
    }
  }
  return orders_row;
};

const updateOrder = (payload, state) => {
  let values = {};
  const findOrder = state.orders.findIndex((item) => item.id == payload.id);
  if (findOrder !== -1) {
    values.orders = [...state.orders];
    values.orders[findOrder] = {
      ...values.orders[findOrder],
      ...payload,
    };
  }
  if (state?.order?.id == payload.id) {
    values.order = { ...state.order, ...payload };
  }
  return values;
};

const postOrderRowGoods = (payload, state) => {
  const orders = [...state.orders];
  const findOrderIndex = orders.findIndex(
    (find) => find.id == payload.items.order_id
  );
  if (findOrderIndex !== -1) {
    orders[findOrderIndex].total_price = payload.total_price;
    const newRow = {
      ...payload.items,
      supplyings: [],
      quantity: Number(payload.items.quantity),
    };
    // Check if order_row already exists to prevent duplicates
    const existingRowIndex = orders[findOrderIndex].order_rows.findIndex(
      (row) => row.id == payload.items.id
    );
    if (existingRowIndex !== -1) {
      orders[findOrderIndex].order_rows = orders[findOrderIndex].order_rows.map(
        (row, idx) => (idx === existingRowIndex ? newRow : row)
      );
    } else {
      orders[findOrderIndex].order_rows = [
        ...orders[findOrderIndex].order_rows,
        newRow,
      ];
    }
  }
  return orders;
};

const updateOrderRowGoods = (payload, state) => {
  const orders = [...state.orders];
  const findOrderIndex = orders.findIndex(
    (find) => find.id == payload.items.order_id
  );
  if (findOrderIndex !== -1) {
    if (payload.total_price) {
      orders[findOrderIndex].total_price = payload.total_price;
    }
    const findOrderRowIndex = orders[findOrderIndex].order_rows.findIndex(
      (find) => find.id == payload.items.id
    );
    if (findOrderRowIndex !== -1) {
      orders[findOrderIndex].order_rows[findOrderRowIndex] = {
        ...orders[findOrderIndex].order_rows[findOrderRowIndex],
        ...payload.items,
        selected: payload.items.disabled_at ? false : payload.items.selected,
      };
    }
  }
  return orders;
};

const updateOrderRowGoodsShow = (payload, state) => {
  const ordersShow = [...state.order_rows];
  const findOrderRowIndex = ordersShow.findIndex(
    (find) => find.id == payload.items.id
  );
  if (findOrderRowIndex !== -1) {
    ordersShow[findOrderRowIndex] = {
      ...ordersShow[findOrderRowIndex],
      ...payload.items,
      selected: payload.items.disabled_at ? false : payload.items.selected,
    };
  }
  return ordersShow;
};

const deleteOrderRowGoods = (payload, state) => {
  const orders = [...state.orders];
  const findOrderIndex = orders.findIndex((find) => find.id == payload.orderId);
  if (findOrderIndex !== -1) {
    orders[findOrderIndex].total_price = payload.total_price;
    orders[findOrderIndex].order_rows = payload.order_rows;
  }
  return orders;
};

const updateOrderRowSupplyings = (payload, state) => {
  const orders = [...state.orders];
  let order_rows = [...state.order_rows];
  const order_id = payload.order_id;
  const findOrderIndex = orders.findIndex((e) => e.id == order_id);
  const findOrderRowIndex = order_rows.findIndex(
    (find) => find.id == payload.service_order_row_id
  );
  if (findOrderRowIndex !== -1) {
    const findOrderRowSupplier = order_rows[
      findOrderRowIndex
    ].supplyings.findIndex((e) => e.id == payload.id);
    if (findOrderRowSupplier !== -1) {
      order_rows[findOrderRowIndex].supplyings[findOrderRowSupplier] = payload;
      if (findOrderIndex !== -1) {
        orders[findOrderIndex].order_rows[findOrderRowIndex].supplyings[
          findOrderRowSupplier
        ] = payload;
      }
    }
  }

  return {
    orders,
    order_rows,
  };
};

const orderRowsBuilder = (order_rows) => {
  const order_rows_builder = order_rows.map((e) => ({
    ...e,
    selected: +e?.quantity > +e.shipments_count && !e.disabled_at,
  }));
  return order_rows_builder;
};

const orderMainRowsBuilder = (orders) => {
  const updated_orders = orders.map((e) => {
    const order_rows = e.order_rows.map((e) => ({
      ...e,
      selected: +e?.quantity > +e.shipments_count && !e.disabled_at,
    }));
    return { ...e, order_rows };
  });
  return updated_orders;
};
